import type { Editor } from '@tiptap/core';
import { EditorState } from '@tiptap/pm/state';

/** Loaded documents are a new editing baseline, never an undoable user edit. */
export function replaceEditorContent(editor: Editor, html: string) {
  editor.chain().setContent(html, { emitUpdate: false }).setMeta('addToHistory', false).run();
  // Discard undo/redo from the previous document as well as initial loading.
  editor.view.updateState(EditorState.create({
    schema: editor.schema,
    doc: editor.state.doc,
    selection: editor.state.selection,
    plugins: editor.state.plugins,
  }));
}
